// Image and description mappings keyed by Supabase UUID
// Names come from Supabase - these only map stable IDs to images/styling

// Product image mappings (by Supabase product ID)
export const productImageMap = {
  '32a78711-942f-494b-8f53-2c1de921fc27': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/b1f4azbl_4.png',
    description: 'Verse knapperige vleugels'
  },
  '90c06955-cd07-4a1d-a87e-d1a73825dc56': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/ln3i8hwk_3.png',
    description: 'Knapperige mini drums'
  },
  '9d14e0fd-0486-466e-addc-0f92c7adc897': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/ppm2d3et_2.png',
    description: 'Malse verse kipfilet'
  }
};

export const defaultProductMeta = {
  image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/pf1hxlds_1.png',
  description: 'Vers bereid'
};

// Flavor image/styling mappings (by Supabase flavor ID)
export const flavorImageMap = {
  'b502ac40-0961-4b64-90b2-c27eed1247a7': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/ayls04dj_CHEESE%20GARLIC.png',
    description: 'Knoflook & kaas smaak',
    tailwindColor: 'from-yellow-400/20 to-yellow-600/10'
  },
  'bc9dbb42-be84-4d52-a2ce-b0ee2a28a949': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/ezzn0ymi_SMOKEY%20WAVE%20.png',
    description: 'Gerookte BBQ smaak',
    tailwindColor: 'from-orange-400/20 to-orange-600/10'
  },
  'cbb36ba9-7272-4398-8407-7346a7ea8618': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/c3xh9nam_PAPRIKA%20SALSA.png',
    description: 'Pittige paprika smaak',
    tailwindColor: 'from-red-400/20 to-red-500/10'
  },
  'e9095f11-92a5-42fe-ad87-0e9ab22613b1': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/b8c1de7a_LEMON%20BURST.png',
    description: 'Zoete citroen smaak',
    tailwindColor: 'from-yellow-300/20 to-lime-400/10'
  },
  '215895a1-51df-4c0a-98fb-bfb9f445bc4c': {
    image: 'https://customer-assets.emergentagent.com/job_d1944924-0552-4e85-a97f-45b688be0de3/artifacts/3qdt8ntm_White%20Truffel.png',
    description: 'Luxe truffelsmaak',
    tailwindColor: 'from-stone-300/20 to-stone-500/10'
  },
  '9560471b-c539-434e-b506-29bbdd50b2a2': {
    image: 'https://customer-assets.emergentagent.com/job_d1944924-0552-4e85-a97f-45b688be0de3/artifacts/fyypuzev_Pineapple%20Pepper.png',
    description: 'Tropisch pittige smaak',
    tailwindColor: 'from-amber-400/20 to-red-400/10'
  },
  '06118cbd-30a9-4107-aff0-6400f0150b80': {
    image: null,
    description: 'Pikante kaas smaak',
    tailwindColor: 'from-green-400/20 to-yellow-400/10'
  }
};

export const defaultFlavorMeta = {
  image: null,
  description: '',
  tailwindColor: 'from-muted/20 to-muted/10'
};

// Side dish image mappings (by Supabase side ID)
export const sideImageMap = {
  '2278169e-7342-4b5d-b7ca-5dddb771a24f': {
    image: 'https://customer-assets.emergentagent.com/job_chicken-order-flow/artifacts/vzkmenjr_iStock-1513599171.jpg'
  },
  'a2bc735a-7f3c-49d5-b385-989ebd90be1c': {
    image: 'https://images.unsplash.com/photo-1707773726979-4b87cd1c838a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxmcmVuY2glMjBmcmllcyUyMGNyaXNweSUyMGdvbGRlbnxlbnwwfHx8fDE3NzE0NDU4NDB8MA&ixlib=rb-4.1.0&q=85'
  },
  '68d03a5c-9729-4234-a675-5bd3f990be8f': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/rtkt23f9_SALADE.png'
  },
  'ec23acf4-8f99-4199-b59b-141722494429': {
    image: 'https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/d4gzty58_MAIS.png'
  }
};

export const defaultSideMeta = {
  image: null
};


// Map DB color string to Tailwind gradient (fallback for unknown IDs)
export const colorToTailwind = {
  'gold': 'from-yellow-400/20 to-yellow-600/10',
  'darkred': 'from-orange-400/20 to-orange-600/10',
  'orange': 'from-red-400/20 to-red-500/10',
  'yellow': 'from-yellow-300/20 to-lime-400/10',
  'cream': 'from-stone-300/20 to-stone-500/10',
  'yellow-orange': 'from-amber-400/20 to-red-400/10',
  'green-yellow': 'from-green-400/20 to-yellow-400/10'
};
